module.exports = __webpack_public_path__ + "img/bubble_layout_5.69188cfe.png";